import { devtools } from 'zustand/middleware';

import {
    type ActiveListing,
    type DaasMarketplaceCollection,
    type MetadataItem,
    type TokenCount,
} from '@app/client/common/structs';
import { create } from '@app/store/zustand/helpers/create';

export type CollectionsMetadata = Record<string, DaasMarketplaceCollection>;
export type ChainCollections = MetadataItem<CollectionsMetadata[]>;
interface FantasyCollectionState {
    collectionsMetadata: MetadataItem<DaasMarketplaceCollection[]>;
    setCollectionsMetadata: (
        updatedMetadataChain: MetadataItem<DaasMarketplaceCollection[]>,
        tokenCounts?: ActiveListing,
    ) => void;
}

export const useFantasyCollectionMetadataStore = create<FantasyCollectionState>()(
    devtools(
        (set) => ({
            collectionsMetadata: {},
            setCollectionsMetadata: (updatedMetadataChain, tokenCounts) =>
                set((state) => {
                    const chainObject = { ...state.collectionsMetadata };
                    for (const chain in updatedMetadataChain) {
                        const stateChainCollections = chainObject[chain];
                        const chainTokens = tokenCounts?.[chain];
                        const chainCollections = updatedMetadataChain[chain] || [];
                        let updatedCollections = stateChainCollections || [];
                        for (const _collection of chainCollections) {
                            const collection = { ..._collection, slug: _collection.slug || _collection.collection_id };
                            const foundItem = stateChainCollections?.find(
                                (col: DaasMarketplaceCollection) => col.slug === collection.slug,
                            );
                            const foundItemTokenCount = chainTokens?.counts?.find(
                                (tokenCount: TokenCount) => tokenCount.slug === collection.slug,
                            );

                            const collectionWithCount = { ...collection, tokenCount: foundItemTokenCount?.count || 0 };
                            if (!foundItem) {
                                updatedCollections = updatedCollections
                                    ? [...updatedCollections, collectionWithCount]
                                    : [collectionWithCount];
                            } else {
                                const indexOfFoundItem = updatedCollections.indexOf(foundItem);
                                updatedCollections[indexOfFoundItem] = { ...collectionWithCount, ...foundItem };
                            }
                        }
                        chainObject[chain] = updatedCollections;
                    }

                    return {
                        collectionsMetadata: chainObject,
                    };
                }),
        }),
        { name: 'fantasy-collection-metadata' },
    ),
);
